import { Component, OnInit } from "@angular/core";
import { RemoteConfig } from "@angular/fire/remote-config";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "src/services/common.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "indiaai";

  constructor(
    private remoteConfig: RemoteConfig,
    private _translateService: TranslateService,
    private _commonService: CommonService
  ) {
    _translateService.addLangs(["en", "de"]);
    this._commonService.setLang(null, "en");
  }

  ngOnInit() {
    this.remoteConfig.settings.minimumFetchIntervalMillis = 24 * 60 * 60 * 1000; // 24hrs
  }
}
